import { IconSquareArrowTopRight } from "central-icons/IconSquareArrowTopRight";
import type { FC, HTMLProps } from "react";

import { fromGitpodSize, type Size } from "@/assets/icons/utils";
import { cn } from "@/components/podkit/lib/cn";

type ExternalLinkProps = {
    iconSize?: Size;
    iconClassName?: string;
} & HTMLProps<HTMLAnchorElement>;

export const ExternalLink: FC<ExternalLinkProps> = ({ iconSize, className, children, iconClassName, ...props }) => {
    return (
        <a
            className={cn("inline-flex items-center gap-1 text-content-link", className)}
            target="_blank"
            rel="noreferrer"
            {...props}
        >
            {children}
            {iconSize && <IconSquareArrowTopRight size={fromGitpodSize(iconSize)} className={iconClassName} />}
        </a>
    );
};
